module.exports = __webpack_public_path__ + "icomoon.31fb7bcccfeecfd0c157.eot";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/fonts/icomoon.eot?mm9zby
// module id = ../../../../../src/assets/fonts/icomoon.eot?mm9zby
// module chunks = styles